import { client } from '@/http';

async function getPushTokenInfo() {
  const response = await client.get('/api/nati/get-push-token-info');
  return response.data;
}

async function updateShouldSendPush(shouldSendPush) {
  const response = await client.patch('/api/nati/update-should-send-push', { shouldSendPush });
  return response.data;
}

export default {
  getPushTokenInfo,
  updateShouldSendPush,
};
